import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgComment = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "var(--icon-color, currentColor)",
	strokeWidth: 1.5,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	className: "lucide lucide-message-circle-icon lucide-message-circle",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M7.9 20A9 9 0 1 0 4 16.1L2 22Z" })
});
export default SvgComment;
